import type { FC } from 'react';

import { NoResults } from '@zen/DesignSystem';

const NetworksContainer: FC = () => {
  return (
    <NoResults
      headline="Please edit Network locations and organisations at the Account level."
      tagline={
        <div className="w-96">
          You can use the drop down switcher in the left hand menu to navigate from this Division to the Account.
        </div>
      }
    />
  );
};

export default NetworksContainer;
